<template>
    <div class="ds-accordion bonusomat-quest-accordion" :class="{ 'is-dark': theme === 'dark' }" ref="parentRef">
        <DsAccordionItem
            :default-open="index == defaultOpenTaskIndex"
            v-for="(item, index) in props.tasks"
            :key="index"
            :item-id="index"
            header-icon-name="chevron-down-thin"
            @expanded="accordionItemExpanded(index)"
        >
            <template #summary>
                <div class="bonusomat-quest-accordion__header">
                    <BonusomatProgress
                        :progress="item.progress"
                        :is-completed="item.progress === 100"
                        always-visible
                        show-percentage-number
                    />{{ item.title }}
                </div>
            </template>
            <template #text>
                <span v-html="item.description"></span>
                <DsButton
                    theme="dark"
                    type="interaction"
                    size="sm"
                    @click="handleOpenModal(item, index)"
                    class="bonusomat-quest__show-games-btn"
                    v-if="item.games?.length"
                    >Zobrazit hry</DsButton
                >
            </template>
        </DsAccordionItem>
    </div>
</template>

<script lang="ts" setup>
import { onMounted, ref, toRef } from "vue";
import DsAccordionItem from "@sazka/design-system/src/accordion-item/ds-accordion-item.vue";
import { useAccordion } from "@sazka/utils/composables/use-accordion";
import { Theme } from "@sazka/design-system/src/types/theme";
import BonusomatProgress from "../shared/bonusomat-progress.vue";
import DsButton from "@sazka/design-system/src/button/ds-button.vue";
import { BonusomatQuestTask } from "../../models/bonusomat-quest-detail";

const parentRef = ref<HTMLElement>(null);

const props = defineProps<{
    /**
     * Set elements
     */
    tasks: BonusomatQuestTask[];
    /**
     * Set index of task to open by default
     */
    defaultOpenTaskIndex: number;
    /**
     * It scrolls task to open into view
     */
    scrollTaskIntoView: boolean;
    /**
     * It scrolls task to open into view
     */
    theme?: Theme;
}>();

const { init } = useAccordion({
    openOnlyOne: false,
    withScrollIntoView: toRef(() => props.scrollTaskIntoView),
});
const emit = defineEmits(["showTaskGames"]);

const handleOpenModal = (taskToShowGames: BonusomatQuestTask, taskIndex: number) => {
    emit("showTaskGames", taskToShowGames, taskIndex);
};

const accordionItemExpanded = (index: number) => {
    if (document.body.classList.contains("firefox") && index >= props.tasks.length - 2) {
        const parentScrollWrapElem = parentRef.value?.closest(".ds-modal-dialog__content");
        if (parentScrollWrapElem) {
            setTimeout(() => {
                parentScrollWrapElem.scrollTo({
                    top: parentScrollWrapElem.scrollHeight,
                    left: 0,
                    behavior: "smooth",
                });
            }, 400);
        }
    }
};

onMounted(() => {
    const allElements = parentRef.value?.querySelectorAll(".ds-accordion-item");

    init(allElements);
});
</script>
